import { useContext } from 'react';
import { Collapse } from '@mui/material';

import CreateAssetModalContext from '../CreateAssetModalContext';

import AttributeGroupRow from './AttributeGroupRow';
import AttributeRow from './AttributeRow';

import classes from './attributesTab.module.css';

const AttributesTab = () => {
  const { schema, collapsedGroups } = useContext(CreateAssetModalContext);

  return (
    <div className={classes.attributesTabContainer}>
      {schema?.attributeGroups?.map(group => (
        <div key={group.id}>
          <AttributeGroupRow key={group.id} attributeGroup={group} />
          <Collapse
            in={!collapsedGroups.has(group.id)}
            timeout="auto"
            unmountOnExit
          >
            <div className={classes.attributeList}>
              {group.attributes.map(attributeId => {
                const attribute = {
                  id: attributeId,
                  ...schema.attributes[attributeId],
                };

                return <AttributeRow key={attributeId} attribute={attribute} />;
              })}
            </div>
          </Collapse>
        </div>
      ))}
    </div>
  );
};

export default AttributesTab;
